function HomePageContent() {
  return (
    <div className="App-block">
      <p>
        <span className="Pulina-highlight">Pulina</span> on uudenlainen tapa esittää osaamistasi, verkostoitua ja kaverustua muiden suomalaisten kanssa.
      </p>
      <p>
        Liity mukaan kokemaan, miltä tuntuu jutella rennosti ilman somepaineita – vain sinä ja muut pulisijat.
      </p>
    </div>
  );
}

export default HomePageContent;

